import envConfig from './config.[envcfg]';

export default {
  domain: 'www.ocado.com',
  ROOT_SHOP_TAG_ID: '20000',

  facebookGraphUrl: '//graph.facebook.com',
  facebookApiVersion: 'v2.10',
  facebookAdmins: '100003285156171',
  facebookScope: 'public_profile,email',
  facebookFields: 'name,email,first_name,last_name',
  androidAppId: 'com.ocado.mobile.android',
  iosAppId: '319691481',
  iosAppName: 'ocado',
  appLinksEnabled: true,

  salutations: ['Mrs', 'Miss', 'Ms', 'Mr', 'Mx', 'Dr'],

  dateFormat: 'ddd DD MMM',
  timeFormat: 'h:mm',
  timeFormatExtended: 'h:mma',
  dateAndTimeFormat: 'ddd DD MMM, h:mm',
  dateAndTimeExtendedFormat: 'ddd DD MMM, h:mma',

  themeColor: '#4D216D',

  seoFromKaleEnabled: true,

  isAddFoodMaestroToSettingArray: true,

  routes: {
    navigation: {
      highlighted: 'top-picks',
    },
  },

  mobileNavigation: {
    corporateSection: [
      {
        sectionId: 'SectionCorporate',
        sectionHeader: 'Corporate',
        childrenIds: ['corporate'],
      },
    ],
    corporateLinks: [
      { name: 'ocadoretail.com', url: 'https://ocadoretail.com/)' },
      { name: 'marksandspencer.com', url: 'https://www.marksandspencer.com/' },
    ],
  },

  fops: {
    // array with section types, which should have repeated ribbon titles every row
    repeatRibbonTitle: [],
    // array with section types, which should have hidden ribbon titles
    hideRibbonTitle: ['PROMO_BOX'],
  },

  bop: {
    // basket control sticky navigation
    basketControls: {
      showShadow: false, // disables shadow
      showRecommendations: false, // disables "Products to buy next" button
    },
    // used in conjunction with BREADCRUMB_ALTERNATIVE beta feature,
    // hides breadcrumbs on BOP for Ocado when the feature is on
    showBreadcrumbs: false,
  },

  feedbackPopup: {
    withHeader: true,
    excludeLocations: [],
  },

  cookieConsent: {
    scriptSrc: 'https://cdn-ukwest.onetrust.com/consent/[domainId]/OtAutoBlock.js',
    dataDomainSrc: 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js',
    domainId: 'e4eb3b2e-4cc5-4752-b2ca-381970849659',
  },

  dynamicYield: {
    dns: [
      '//cdn-eu.dynamicyield.com', '//st-eu.dynamicyield.com', '//rcom-eu.dynamicyield.com',
    ],
    js: {
      dynamic: '//cdn-eu.dynamicyield.com/api/[site_id]/api_dynamic.js',
      static: '//cdn-eu.dynamicyield.com/api/[site_id]/api_static.js',
    },
    siteId: envConfig.dynamicYieldSiteId,
    api: {
      url: '//direct-collect.dy-api.eu/v2/collect/user',
      key: envConfig.dynamicYieldApiKey,
    },
  },

  citrusScriptUrl: 'https://assets.citrusad.net/citrusjs/1.2.0/citrus.js',

  // environment (CIT/DEV or PROD) specific config values
  // may override the generic config values
  // IMPORTANT: MUST GO AS LAST ENTRY
  ...envConfig,
};
